import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppTester } from "supporting";
import * as yup from 'yup';

export const useGetExtraCompetitionConfig = (competitionId?: string) => {
    const isDamuseum = AppTester.isDaMuseum();
    const isGeo = AppTester.isGeograffee();
    const isCGRave = AppTester.isCGRAVE()
    const isCompetition = AppTester.isCompetition();
    const { t, i18n: {language} } = useTranslation();
    const [extraConfig, setExtraConfig] = useState<any>();

    const agreementDocumentRoute = 'https://www.hse.ru/data_protection_regulation';
    const personalDataDocumentRoute = useMemo(() => {
        return (
            isGeo ? ( language === 'ru' ? process.env.REACT_APP_URL_GEOGRAPHY_RU 
                : process.env.REACT_APP_URL_GEOGRAPHY_EN)
            : isCompetition ? process.env.REACT_APP_URL_DEZIIIGN : 
            ( language === 'ru' ? process.env.REACT_APP_URL_HSEDESIGN_RU 
            : process.env.REACT_APP_URL_HSEDESIGN_EN) ) + '/legals';
    }, [language, isGeo, isCompetition])

    const agreementVKroute = 'https://cloud.mail.ru/public/WKsy/TBiAUF6oR';

    const newWorldRoute = 'https://drive.google.com/file/d/1qtD1ArjDRI_TUVxli3B-TvCYrphRrPEV/view?usp=sharing';

    const isNewWorldCompetitions = useMemo(() => {
        return competitionId && competitionId === 'f27288337dbf4989888d800ac226a44f'
    } , [competitionId])

    const isVegaCompetition = useMemo(() => {
        return competitionId && competitionId === 'e7da5f11a1284d09b10c50e59e4f338e'
      } , [])

    useEffect(() => {
        if (isVegaCompetition) {
            setExtraConfig({
                agreeOne: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Подтверждаю, что ознакомлен(а) с 
                            <a href={'https://drive.google.com/file/d/13dzA_-X11GiM3qzYSwRWL43Dk6LDHP3O/view?usp=sharing'} target={'_BLANK'}> Положением конкурса</a>
                            ,
                            <a href={'https://drive.google.com/file/d/1PCB_e85jjsyoqfwfgIWpPce4VaI4niAg/view?usp=sharing'} target={'_BLANK'}> Техническим заданием </a>
                            и
                            <a href={'https://drive.google.com/file/d/1JbwrRqBEevQGmdHggJUfx0BmF4tbotuz/view?usp=sharing'} target={'_BLANK'}> Соглашением об участии</a>
                            , и согласен(а) с условиями участия.
                        </span>
                    ) : (
                        <span>I confirm that I have read
                            <a href="https://drive.google.com/file/d/13dzA_-X11GiM3qzYSwRWL43Dk6LDHP3O/view?usp=sharing" target="_BLANK"> the Competition Regulations</a>
                            ,
                            <a href="https://drive.google.com/file/d/1PCB_e85jjsyoqfwfgIWpPce4VaI4niAg/view?usp=sharing" target="_BLANK"> the Terms of Reference </a>
                            and 
                            <a href="https://drive.google.com/file/d/1JbwrRqBEevQGmdHggJUfx0BmF4tbotuz/view?usp=sharing" target="_BLANK"> the Participation Agreement</a>
                            , and I agree to the terms of participation.
                        </span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                    defaultValue: false,
                },
                agreeTwo: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Подтверждаю, что представленный проект является моей оригинальной работой, созданной специально для данного конкурса, ранее нигде не публиковался, не реализовывался, не передавался третьим лицам и не нарушает права третьих лиц.</span>
                    ) : (
                        <span>I confirm that the submitted project is my original work, created specifically for this competition, has not been previously published or implemented anywhere, has not been transferred to third parties, and does not infringe the rights of any third parties.</span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                    defaultValue: false,
                },
            })
        }
        else if (isDamuseum) {
            setExtraConfig({
                agreeOne: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Подтверждаю, что ознакомлен (-на) и согласен (-на) с Положением о Конкурсе ВМДПНИ</span>
                    ) : (
                        <span>I confirm that I have read and agree with the Regulations on the VMDPNI Competition</span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                    defaultValue: false,
                },
                agreeTwo: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Подтверждаю, что ознакомлен (-на) и согласен (-на) с публичной офертой.</span>
                    ) : (
                        <span>I confirm that I have read and agree to the public offer.</span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                    defaultValue: false,
                },
                agreeThree: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Подтверждаю, что введенная информация об авторах полная и достоверная, а также что имею право на участие в конкурсе.</span>
                    ) : (
                        <span>I confirm that the information entered about the authors is complete and reliable, and that I am eligible to participate in the competition.</span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                    defaultValue: false,
                },
                agreeFour: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Согласен на обработку персональных данных в соответствии с п. 20.1. Положения о Конкурсе.</span>
                    ) : (
                        <span>I agree to the processing of personal data in accordance with clause 20.1. of the Competition Regulations.</span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                        defaultValue: false,
                },
                agreeFive: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Я соглашаюсь с <a href={personalDataDocumentRoute} target={'_BLANK'}>Пользовательским соглашением</a> ресурсов hsedesign.com и hsedesign.ru</span>
                    ) : (
                        <span>I agree to the <a href={personalDataDocumentRoute} target={'_BLANK'}>User Agreement</a> of the resources hsedesign.com and hsedesign.ru</span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                        defaultValue: false,
                },
                agreeSix: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Я соглашаюсь с <a href={agreementDocumentRoute} target={'_BLANK'}>Политикой конфиденциальности и обработки персональных данных</a></span>
                    ) : (
                        <span>I agree to <a href={agreementDocumentRoute} target={'_BLANK'}>the Privacy and Personal Data Processing Policy</a></span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                        defaultValue: false,
                },
            })
        } /*else if (isCgRaveCompetitions) {
            setExtraConfig({
                agreeOne: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Я даю согласие на обработку персональных данных в порядке и на условиях <a href={'https://docs.google.com/document/d/1N7KT-okj1JofL6qQNV5g889D5QJ2fmELY9CYwTLqfRQ/pub'} target={'_BLANK'}>Политики обработки персональных данных</a> </span>
                    ) : (
                        <span>
                            I consent to the processing of personal data in the manner and under<a href={'https://tickets.damuseum.ru/event/18BD9CE4FB788F27FEDC515F652E2A2165D5CC9B'} target={'_BLANK'}>the conditions</a> <a href={'https://docs.google.com/document/d/1N7KT-okj1JofL6qQNV5g889D5QJ2fmELY9CYwTLqfRQ/pub'} target={'_BLANK'}>Personal data processing policies</a></span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                        defaultValue: false,
                },
                agreeTwo: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Я принимаю условия <a href={'https://docs.google.com/document/d/1kLkssEpLyb6iHjXmlzqj9JUSsSW6DG8V/pub'} target={'_BLANK'}>Лицензионного соглашения</a> и  <a href={'https://docs.google.com/document/d/1mLQIX4iH300bj2dubBw61Y0CwyYDqbIw3ta-MjV6IL4/pub'} target={'_BLANK'}>Положение о конкурсе</a></span>
                    ) : (
                        <span>I accept the terms of <a href={'https://docs.google.com/document/d/1kLkssEpLyb6iHjXmlzqj9JUSsSW6DG8V/pub'} target={'_BLANK'}>the License Agreement</a> and <a href={'https://docs.google.com/document/d/1mLQIX4iH300bj2dubBw61Y0CwyYDqbIw3ta-MjV6IL4/pub'} target={'_BLANK'}>Regulations on the competition</a> </span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                        defaultValue: false,
                },
            })
        } else if (isVKCompetition) {
            setExtraConfig({
                agreeOne: {
                    type: 'checkbox',
                    label: '',
                    name: 'agreeOne',
                    checkboxLabel: language === 'ru' ? (
                        <span>Я соглашаюсь с <a href={personalDataDocumentRoute} target={'_BLANK'}>Пользовательским соглашением</a> ресурсов hsedesign.com и hsedesign.ru</span>
                    ) : (
                        <span>I agree to the <a href={personalDataDocumentRoute} target={'_BLANK'}>User Agreement</a> of the resources hsedesign.com and hsedesign.ru</span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                        defaultValue: false,
                },
                agreeTwo: {
                    type: 'checkbox',
                    label: '',
                    name: 'agreeTwo',
                    checkboxLabel: language === 'ru' ? (
                        <span>Я соглашаюсь с <a href={agreementDocumentRoute} target={'_BLANK'}>Политикой конфиденциальности и обработки персональных данных</a></span>
                    ) : (
                        <span>I agree to <a href={agreementDocumentRoute} target={'_BLANK'}>the Privacy and Personal Data Processing Policy</a></span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                        defaultValue: false,
                },
                agreeThree: {
                    type: 'checkbox',
                    label: '',
                    name: 'agreeThree',
                    checkboxLabel: language === 'ru' ? (
                        <span>Я соглашаюсь с <a href={agreementVKroute} target={'_BLANK'}>Положением о конкурсе</a></span>
                    ) : (
                        <span>I agree to the <a href={agreementVKroute} target={'_BLANK'}>Regulations on the competition</a></span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                    defaultValue: false,
                },
            })
        } */else {
            setExtraConfig({
                agreeOne: {
                    type: 'checkbox',
                    label: '',
                    name: 'agreeOne',
                    checkboxLabel: language === 'ru' ? (
                        <span>Я соглашаюсь с <a href={personalDataDocumentRoute} target={'_BLANK'}>Пользовательским соглашением</a> ресурсов hsedesign.com и hsedesign.ru</span>
                    ) : (
                        <span>I agree to the <a href={personalDataDocumentRoute} target={'_BLANK'}>User Agreement</a> of the resources hsedesign.com and hsedesign.ru</span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                    defaultValue: false,
                },
                agreeTwo: {
                    type: 'checkbox',
                    label: '',
                    name: 'agreeTwo',
                    checkboxLabel: language === 'ru' ? (
                        <span>Я соглашаюсь с <a href={agreementDocumentRoute} target={'_BLANK'}>Политикой конфиденциальности и обработки персональных данных</a></span>
                    ) : (
                        <span>I agree to <a href={agreementDocumentRoute} target={'_BLANK'}>the Privacy and Personal Data Processing Policy</a></span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                    defaultValue: false,
                },
                ...(isNewWorldCompetitions ? {
                    agreeThree: {
                        type: 'checkbox',
                        label: '',
                        name: 'agreeThree',
                        checkboxLabel: language === 'ru' ? (
                            <span>Я соглашаюсь c <a href={newWorldRoute} target={'_BLANK'}>Положением о конкурсе «Новые Миры, Новые Герои»</a></span>
                        ) : (
                            <span>I agree to <a href={newWorldRoute} target={'_BLANK'}>Regulation on the Competition «New Worlds, New Heroes</a></span>
                        ),
                        requiredLabel: true,
                        validation: yup
                            .boolean()
                            .oneOf([true], t('competition_edit.form.message.required.agree'))
                            .required(t('competition_edit.form.message.required.required_field')),
                        defaultValue: false,
                    },
                } : {})
            })
        }
    } , [language])

    if (!competitionId) return {}

    return extraConfig
}import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppTester } from "supporting";
import * as yup from 'yup';

export const useGetExtraCompetitionConfig = (competitionId?: string) => {
    const isDamuseum = AppTester.isDaMuseum();
    const isGeo = AppTester.isGeograffee();
    const isCGRave = AppTester.isCGRAVE()
    const isCompetition = AppTester.isCompetition();
    const { t, i18n: {language} } = useTranslation();
    const [extraConfig, setExtraConfig] = useState<any>();

    const agreementDocumentRoute = 'https://www.hse.ru/data_protection_regulation';
    const personalDataDocumentRoute = useMemo(() => {
        return (
            isGeo ? ( language === 'ru' ? process.env.REACT_APP_URL_GEOGRAPHY_RU 
                : process.env.REACT_APP_URL_GEOGRAPHY_EN)
            : isCompetition ? process.env.REACT_APP_URL_DEZIIIGN : 
            ( language === 'ru' ? process.env.REACT_APP_URL_HSEDESIGN_RU 
            : process.env.REACT_APP_URL_HSEDESIGN_EN) ) + '/legals';
    }, [language, isGeo, isCompetition])

    const agreementVKroute = 'https://cloud.mail.ru/public/WKsy/TBiAUF6oR';

    const newWorldRoute = 'https://drive.google.com/file/d/1qtD1ArjDRI_TUVxli3B-TvCYrphRrPEV/view?usp=sharing';

    const isNewWorldCompetitions = useMemo(() => {
        return competitionId && competitionId === 'f27288337dbf4989888d800ac226a44f'
    } , [competitionId])

    const isVegaCompetition = useMemo(() => {
        return competitionId && competitionId === 'e7da5f11a1284d09b10c50e59e4f338e'
      } , [])

    useEffect(() => {
        if (isVegaCompetition) {
            setExtraConfig({
                agreeOne: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Подтверждаю, что ознакомлен(а) с 
                            <a href={'https://drive.google.com/file/d/13dzA_-X11GiM3qzYSwRWL43Dk6LDHP3O/view?usp=sharing'} target={'_BLANK'}> Положением конкурса</a>
                            ,
                            <a href={'https://drive.google.com/file/d/1PCB_e85jjsyoqfwfgIWpPce4VaI4niAg/view?usp=sharing'} target={'_BLANK'}> Техническим заданием </a>
                            и
                            <a href={'https://drive.google.com/file/d/1JbwrRqBEevQGmdHggJUfx0BmF4tbotuz/view?usp=sharing'} target={'_BLANK'}> Соглашением об участии</a>
                            , и согласен(а) с условиями участия.
                        </span>
                    ) : (
                        <span>I confirm that I have read
                            <a href="https://drive.google.com/file/d/13dzA_-X11GiM3qzYSwRWL43Dk6LDHP3O/view?usp=sharing" target="_BLANK"> the Competition Regulations</a>
                            ,
                            <a href="https://drive.google.com/file/d/1PCB_e85jjsyoqfwfgIWpPce4VaI4niAg/view?usp=sharing" target="_BLANK"> the Terms of Reference </a>
                            and 
                            <a href="https://drive.google.com/file/d/1JbwrRqBEevQGmdHggJUfx0BmF4tbotuz/view?usp=sharing" target="_BLANK"> the Participation Agreement</a>
                            , and I agree to the terms of participation.
                        </span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                    defaultValue: false,
                },
                agreeTwo: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Подтверждаю, что представленный проект является моей оригинальной работой, созданной специально для данного конкурса, ранее нигде не публиковался, не реализовывался, не передавался третьим лицам и не нарушает права третьих лиц.</span>
                    ) : (
                        <span>I confirm that the submitted project is my original work, created specifically for this competition, has not been previously published or implemented anywhere, has not been transferred to third parties, and does not infringe the rights of any third parties.</span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                    defaultValue: false,
                },
            })
        }
        else if (isDamuseum) {
            setExtraConfig({
                agreeOne: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Подтверждаю, что ознакомлен (-на) и согласен (-на) с Положением о Конкурсе ВМДПНИ</span>
                    ) : (
                        <span>I confirm that I have read and agree with the Regulations on the VMDPNI Competition</span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                    defaultValue: false,
                },
                agreeTwo: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Подтверждаю, что ознакомлен (-на) и согласен (-на) с публичной офертой.</span>
                    ) : (
                        <span>I confirm that I have read and agree to the public offer.</span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                    defaultValue: false,
                },
                agreeThree: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Подтверждаю, что введенная информация об авторах полная и достоверная, а также что имею право на участие в конкурсе.</span>
                    ) : (
                        <span>I confirm that the information entered about the authors is complete and reliable, and that I am eligible to participate in the competition.</span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                    defaultValue: false,
                },
                agreeFour: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Согласен на обработку персональных данных в соответствии с п. 20.1. Положения о Конкурсе.</span>
                    ) : (
                        <span>I agree to the processing of personal data in accordance with clause 20.1. of the Competition Regulations.</span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                        defaultValue: false,
                },
                agreeFive: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Я соглашаюсь с <a href={personalDataDocumentRoute} target={'_BLANK'}>Пользовательским соглашением</a> ресурсов hsedesign.com и hsedesign.ru</span>
                    ) : (
                        <span>I agree to the <a href={personalDataDocumentRoute} target={'_BLANK'}>User Agreement</a> of the resources hsedesign.com and hsedesign.ru</span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                        defaultValue: false,
                },
                agreeSix: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Я соглашаюсь с <a href={agreementDocumentRoute} target={'_BLANK'}>Политикой конфиденциальности и обработки персональных данных</a></span>
                    ) : (
                        <span>I agree to <a href={agreementDocumentRoute} target={'_BLANK'}>the Privacy and Personal Data Processing Policy</a></span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                        defaultValue: false,
                },
            })
        } /*else if (isCgRaveCompetitions) {
            setExtraConfig({
                agreeOne: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Я даю согласие на обработку персональных данных в порядке и на условиях <a href={'https://docs.google.com/document/d/1N7KT-okj1JofL6qQNV5g889D5QJ2fmELY9CYwTLqfRQ/pub'} target={'_BLANK'}>Политики обработки персональных данных</a> </span>
                    ) : (
                        <span>
                            I consent to the processing of personal data in the manner and under<a href={'https://tickets.damuseum.ru/event/18BD9CE4FB788F27FEDC515F652E2A2165D5CC9B'} target={'_BLANK'}>the conditions</a> <a href={'https://docs.google.com/document/d/1N7KT-okj1JofL6qQNV5g889D5QJ2fmELY9CYwTLqfRQ/pub'} target={'_BLANK'}>Personal data processing policies</a></span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                        defaultValue: false,
                },
                agreeTwo: {
                    type: 'checkbox',
                    label: '',
                    checkboxLabel: language === 'ru' ? (
                        <span>Я принимаю условия <a href={'https://docs.google.com/document/d/1kLkssEpLyb6iHjXmlzqj9JUSsSW6DG8V/pub'} target={'_BLANK'}>Лицензионного соглашения</a> и  <a href={'https://docs.google.com/document/d/1mLQIX4iH300bj2dubBw61Y0CwyYDqbIw3ta-MjV6IL4/pub'} target={'_BLANK'}>Положение о конкурсе</a></span>
                    ) : (
                        <span>I accept the terms of <a href={'https://docs.google.com/document/d/1kLkssEpLyb6iHjXmlzqj9JUSsSW6DG8V/pub'} target={'_BLANK'}>the License Agreement</a> and <a href={'https://docs.google.com/document/d/1mLQIX4iH300bj2dubBw61Y0CwyYDqbIw3ta-MjV6IL4/pub'} target={'_BLANK'}>Regulations on the competition</a> </span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                        defaultValue: false,
                },
            })
        } else if (isVKCompetition) {
            setExtraConfig({
                agreeOne: {
                    type: 'checkbox',
                    label: '',
                    name: 'agreeOne',
                    checkboxLabel: language === 'ru' ? (
                        <span>Я соглашаюсь с <a href={personalDataDocumentRoute} target={'_BLANK'}>Пользовательским соглашением</a> ресурсов hsedesign.com и hsedesign.ru</span>
                    ) : (
                        <span>I agree to the <a href={personalDataDocumentRoute} target={'_BLANK'}>User Agreement</a> of the resources hsedesign.com and hsedesign.ru</span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                        defaultValue: false,
                },
                agreeTwo: {
                    type: 'checkbox',
                    label: '',
                    name: 'agreeTwo',
                    checkboxLabel: language === 'ru' ? (
                        <span>Я соглашаюсь с <a href={agreementDocumentRoute} target={'_BLANK'}>Политикой конфиденциальности и обработки персональных данных</a></span>
                    ) : (
                        <span>I agree to <a href={agreementDocumentRoute} target={'_BLANK'}>the Privacy and Personal Data Processing Policy</a></span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                        defaultValue: false,
                },
                agreeThree: {
                    type: 'checkbox',
                    label: '',
                    name: 'agreeThree',
                    checkboxLabel: language === 'ru' ? (
                        <span>Я соглашаюсь с <a href={agreementVKroute} target={'_BLANK'}>Положением о конкурсе</a></span>
                    ) : (
                        <span>I agree to the <a href={agreementVKroute} target={'_BLANK'}>Regulations on the competition</a></span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                    defaultValue: false,
                },
            })
        } */else {
            setExtraConfig({
                agreeOne: {
                    type: 'checkbox',
                    label: '',
                    name: 'agreeOne',
                    checkboxLabel: language === 'ru' ? (
                        <span>Я соглашаюсь с <a href={personalDataDocumentRoute} target={'_BLANK'}>Пользовательским соглашением</a> ресурсов hsedesign.com и hsedesign.ru</span>
                    ) : (
                        <span>I agree to the <a href={personalDataDocumentRoute} target={'_BLANK'}>User Agreement</a> of the resources hsedesign.com and hsedesign.ru</span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                    defaultValue: false,
                },
                agreeTwo: {
                    type: 'checkbox',
                    label: '',
                    name: 'agreeTwo',
                    checkboxLabel: language === 'ru' ? (
                        <span>Я соглашаюсь с <a href={agreementDocumentRoute} target={'_BLANK'}>Политикой конфиденциальности и обработки персональных данных</a></span>
                    ) : (
                        <span>I agree to <a href={agreementDocumentRoute} target={'_BLANK'}>the Privacy and Personal Data Processing Policy</a></span>
                    ),
                    requiredLabel: true,
                    validation: yup
                        .boolean()
                        .oneOf([true], t('competition_edit.form.message.required.agree'))
                        .required(t('competition_edit.form.message.required.required_field')),
                    defaultValue: false,
                },
                ...(isNewWorldCompetitions ? {
                    agreeThree: {
                        type: 'checkbox',
                        label: '',
                        name: 'agreeThree',
                        checkboxLabel: language === 'ru' ? (
                            <span>Я соглашаюсь c <a href={newWorldRoute} target={'_BLANK'}>Положением о конкурсе «Новые Миры, Новые Герои»</a></span>
                        ) : (
                            <span>I agree to <a href={newWorldRoute} target={'_BLANK'}>Regulation on the Competition «New Worlds, New Heroes</a></span>
                        ),
                        requiredLabel: true,
                        validation: yup
                            .boolean()
                            .oneOf([true], t('competition_edit.form.message.required.agree'))
                            .required(t('competition_edit.form.message.required.required_field')),
                        defaultValue: false,
                    },
                } : {})
            })
        }
    } , [language])

    if (!competitionId) return {}

    return extraConfig
}